import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { InventoryService } from '../inventory.service';
import { GlobalResponse, DrugRequest } from '../../shared-module/models';
import { Constants } from '../../shared-module/constants';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-create-drug-dialog',
  templateUrl: './create-drug-dialog.component.html',
  styleUrls: ['./create-drug-dialog.component.css']
})
export class CreateDrugDialogComponent implements OnInit {
  public headerTitle: string;
  public doctorId: string;
  public clinicId: string;
  public drugId: string;
  public category: string;
  public rack_no: string;
  public manufacturer: string;
  public instructions: string;
  public seller_name: string;
  // public name: string;
  public qty = 0;
  public price = 0;
  public buyPrice = 0;
  // public batchFlag = false;
  inventoryCache: any = {} as any;
  nameData: any[] = [];
  name_selected: any;

  // mfg_date: any;
  expiry_date: any;
  current_date: any = new Date();
  @BlockUI() blockUI: NgBlockUI;
  // public myDatePickerOptionsMfg: IMyDpOptions = {
  //   dateFormat: 'yyyy-mm-dd',
  //   editableDateField: false,
  //   openSelectorOnInputClick: true,
  //   showClearDateBtn: true,
  //   disableSince: { year: this.current_date.getFullYear(), month: this.current_date.getMonth() + 1, day: this.current_date.getDate() }
  // };
  public myDatePickerOptionsExp: IMyDpOptions = {
    dateFormat: Constants.DATE_FORMAT,
    editableDateField: false,
    openSelectorOnInputClick: true,
    showClearDateBtn: true,
    disableUntil: { year: this.current_date.getFullYear(), month: this.current_date.getMonth() + 1, day: this.current_date.getDate() }
  };

  constructor(
    public dialogRef: MatDialogRef<CreateDrugDialogComponent>,
    private service: InventoryService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.categoryChanged();
  }

  categoryChanged() {
    this.nameData = [];
    // if (!this.inventoryCache) {
    //   if (!this.inventoryCache[this.category]) {
    this.blockUI.start();
    this.service.getDrugList(this.clinicId, this.category, 0, 0)
      .subscribe((res: GlobalResponse) => {
        this.blockUI.stop();
        if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
          // let tempDrug: any = {} as any;
          this.nameData = res.result.drugs;
          // console.log(this.inventoryList);
          // this.length = res.result.drugsCount;
        }
      });
    //   } else {
    //     this.nameData = this.inventoryCache[this.category];
    //   }
    // }
  }

  addName = (term) => ({ name: term });

  onNameChange = event => {
    // console.log(this.name_selected);
    if (this.name_selected && this.name_selected.name !== 'Select') {
      this.manufacturer = this.name_selected.manufacturer ? this.name_selected.manufacturer : '';
      this.instructions = this.name_selected.instructions ? this.name_selected.instructions : '';
      this.seller_name = this.name_selected.seller_name ? this.name_selected.seller_name : '';
      if (this.name_selected.seller_name) {
        this.seller_name = this.name_selected.seller_name;
      } else if (this.name_selected.supplier) {
        this.seller_name = this.name_selected.supplier;
      }
    } else {
      this.name_selected = { _id: null, name: 'Select' };
      this.manufacturer = '';
      this.instructions = '';
      this.seller_name = '';
    }
  }

  onNameClear = event => {
    this.name_selected = { _id: null, name: 'Select' };
  }

  createItem() {
    if (this.category && this.category !== '') {
      if (this.price && this.price >= 0 &&
        this.name_selected && this.name_selected.name !== 'Select' &&
        ((this.qty && this.qty !== 0 && this.category !== Constants.OTHERS_VALUE)
          || this.category === Constants.OTHERS_VALUE)) {
        if (this.name_selected._id && this.category !== Constants.OTHERS_VALUE) {
          this.createBatchItem();
        } else {
          this.blockUI.start();
          const newItem: DrugRequest = {} as DrugRequest;
          newItem.category = this.category;
          newItem.name = this.name_selected.name;
          newItem.selling_price = this.price;
          newItem.qty = this.qty;
          newItem.buying_price = this.buyPrice;
          // newItem.seller_name = this.seller_name;
          newItem.supplier = this.seller_name;
          newItem.rack_no = this.rack_no;
          newItem.manufacturer = this.manufacturer;
          newItem.instructions = this.instructions;
          if (this.expiry_date && this.expiry_date.date) {
            newItem.expiry_date = this.expiry_date.date.year + '-' + this.expiry_date.date.month + '-' + this.expiry_date.date.day;
          }
          // newItem.mfg_date = this.mfg_date ? this.mfg_date : '';
          this.service.createDrug(newItem).subscribe((res: GlobalResponse) => {
            this.blockUI.stop();
            if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
              // console.log(res.result);
              this.dialogRef.close(newItem);
            }
          });
        }
      } else {
        this.toastr.error('Fill in the * marked mandatory fields');
      }
    } else {
      this.toastr.error('Please select category before proceeding');
    }
  }

  createBatchItem() {
    // if (this.qty && this.qty !== 0 && this.expiry_date &&
    //   this.manufacturer && this.manufacturer !== '') {
    const newItem: DrugRequest = {} as DrugRequest;
    // newItem.name = this.name_selected.name;
    newItem.qty = this.qty;
    newItem.buying_price = this.buyPrice;
    newItem.selling_price = this.price;
    // newItem.seller_name = this.seller_name;
    newItem.rack_no = this.rack_no;
    // newItem.manufacturer = this.manufacturer;
    // newItem.instructions = this.instructions;
    newItem.drugId = this.name_selected._id;
    if (this.expiry_date && this.expiry_date.date) {
      newItem.expiry_date = this.expiry_date.date.year + '-' + this.expiry_date.date.month + '-' + this.expiry_date.date.day;
    }
    // newItem.mfg_date = this.mfg_date ? this.mfg_date : '';
    this.blockUI.start();
    this.service.createBatch(this.clinicId, newItem).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.dialogRef.close(newItem);
      }
    });
    // } else {
    //   this.toastr.error('Please enter mandatory fields');
    // }
  }

  onNextDateChanged = (event: IMyDateModel) => {
    // console.log(event);
    // console.log(event.formatted);
    // if (type === 'mfg') {
    //   this.mfg_date = event.formatted;
    // } else {
    this.expiry_date = event;
    // }
    // console.log(this.mfg_date);
    // console.log(this.expiry_date);
  }

}
